import { render, staticRenderFns } from "./ButtonTip.vue?vue&type=template&id=2f5dbfcd&scoped=true"
import script from "./ButtonTip.vue?vue&type=script&lang=js"
export * from "./ButtonTip.vue?vue&type=script&lang=js"
import style0 from "./ButtonTip.vue?vue&type=style&index=0&id=2f5dbfcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dbfcd",
  null
  
)

export default component.exports